import React, { useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import bgImage from "../assets/image.png";

const PaymentStatus = () => {
  const location = useLocation();

  const query = new URLSearchParams(location.search);
  const status = query.get("status");

  useEffect(() => {
    if (status !== "Pending") {
      console.log("Payment status: ", status);
      window.close();
    }
  }, [status]);

  const renderMessage = () => {
    if (status === "TXN_SUCCESS") {
      return (
        <div
          style={{
            textAlign: "center",
            width: "100%",
            height: "100vh",
            backgroundImage: `url(${bgImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <h1
            style={{
              marginTop: "40px",
              fontSize: "24px",
              fontWeight: "bold",
              color: "#000",
            }}
          >
            Success
          </h1>
          <p
            style={{
              marginTop: "8px",
              color: "#000",
              fontWeight: "600",
              fontSize: "16px",
            }}
          >
            Your order will be delivered soon. Thank you for choosing our app
          </p>
        </div>
      );
    } else if (status === "TXN_FAIL") {
      return (
        <div
          style={{
            textAlign: "center",
          }}
        >
          <h1
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              color: "red",
            }}
          >
            Payment Failed!
          </h1>
          <p
            style={{
              marginTop: "8px",
            }}
          >
            Please try again or contact support if the issue persists.
          </p>
        </div>
      );
    } else {
      return (
        <div
          style={{
            textAlign: "center",
          }}
        >
          <h1
            style={{
              fontSize: "24px",
              fontWeight: "bold",
              color: "gray",
            }}
          >
            Invalid Status
          </h1>
          <p
            style={{
              marginTop: "8px",
            }}
          >
            We couldn't determine the payment status. Please try again.
          </p>
        </div>
      );
    }
  };

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
      }}
    >
      {renderMessage()}
    </div>
  );
};

export default PaymentStatus;
